import PopUp from '../../PopUp';
import HandsPopUp from '../handsPopUp/HandsPopUp';
import { useState } from 'react';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	Wrapper,
	Text,
	HandsContainer,
	HandButton,
	HandIcon,
} from './RateFeaturePopUp.styled';
import Like from '../images/ok.svg';
import Dislike from '../images/not.svg';
import { HAND_DECISION } from '@/common/constants/handDecision';

const RateFeaturePopUp = ({ type, forWhat, onClose }) => {
	const [decision, setDecision] = useState();
	const { giveUsInfo, skip } = useLanguageData('hands');

	return !decision ? (
		<PopUp setClose={onClose}>
			<Wrapper>
				<Text>{giveUsInfo}</Text>
				<HandsContainer>
					<HandButton
						onClick={() => {
							setDecision(HAND_DECISION.UP);
						}}
					>
						<HandIcon src={Like} />
					</HandButton>
					<HandButton
						onClick={() => {
							setDecision(HAND_DECISION.DOWN);
						}}
					>
						<HandIcon src={Dislike} />
					</HandButton>
				</HandsContainer>
				<Text onClick={onClose}>{skip}</Text>
			</Wrapper>
		</PopUp>
	) : (
		<HandsPopUp
			decision={decision}
			setDecision={(v) => {
				setDecision(v);
				onClose();
			}}
			type={type}
			forWhat={forWhat}
		/>
	);
};

export default RateFeaturePopUp;
